import {
  DatePicker as BlueprintDatePicker,
  IDateFormatProps,
} from '@blueprintjs/datetime'
import React from 'react'

export interface DatePickerProps {
  onChange: (Date: Date) => void
  date: Date | null
  showActionsBar?: boolean
  shortcuts?: boolean
  disableFutureDates?: boolean
  disablePastDates?: boolean
  maxDate?: Date
  minDate?: Date
  highlightCurrentDay?: boolean
}

const jsDateFormatter: IDateFormatProps = {
  // note that the native implementation of Date functions differs between browsers
  formatDate: date => date.toLocaleDateString(),
  parseDate: str => new Date(str),
  invalidDateMessage: 'Invalid Date',
}

const DatePicker = ({
  onChange,
  showActionsBar = true,
  shortcuts,
  disableFutureDates = false,
  maxDate,
  disablePastDates = false,
  minDate,
  date,
  highlightCurrentDay = true,
}: DatePickerProps) => {
  const datePickerMaxDate = disableFutureDates ? new Date() : undefined
  const datePickerMinDate = disablePastDates ? new Date() : undefined
  return (
    <BlueprintDatePicker
      {...jsDateFormatter}
      value={date}
      onChange={onChange}
      showActionsBar={showActionsBar}
      shortcuts={shortcuts}
      highlightCurrentDay={highlightCurrentDay}
      maxDate={maxDate || datePickerMaxDate}
      minDate={minDate || datePickerMinDate}
    />
  )
}

export default DatePicker
